<p>detail-prescription-hospit works!</p>
